import NumberArrowKeySupport from 'utils/form_elements/number_arrowkeys_support';
import NumberPlusMinusButtons from 'utils/form_elements/number_plus_minus_buttons';
import {WishlistController} from 'components/wishlist_controller';
import {TrackingListener} from '../tracking/google/360/tracking_listener';
import {CartListener} from '../tracking/google/ga4/cart_listener';

export default function Wishlist() {
  new NumberArrowKeySupport().init();
  new NumberPlusMinusButtons().init();
  WishlistController();
  TrackingListener();
  CartListener();
}